export default __webpack_public_path__ + "static/media/discord.44d84b0f.svg";